import { render, staticRenderFns } from "./RedemptionsSummaryTable.vue?vue&type=template&id=2257972e&"
import script from "./RedemptionsSummaryTable.vue?vue&type=script&lang=js&"
export * from "./RedemptionsSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./RedemptionsSummaryTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports